import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  CreateDepartmentTicketDto,
  CreateDepartmentTicketCommentDto,
  DepartmentTicketCommentDto,
  DepartmentTicketDetailsDto,
  DepartmentTicketStatus,
  DepartmentTicketSummaryDto,
} from "../interfaces/Tickets/departmentTicket";

const authHeaders = (token: string) => ({ Authorization: `Bearer ${token}` });

export const getDepartmentTickets = async (
  token: string,
  employeeId: string,
) => {
  const { data } = await axios.get<DepartmentTicketSummaryDto[]>(
    `${apiVariable}/departmentTickets`,
    { headers: authHeaders(token), params: { employeeId } },
  );
  return data;
};

export const getAllDepartmentTicketsForHelpers = async (token: string) => {
  const { data } = await axios.get<DepartmentTicketSummaryDto[]>(
    `${apiVariable}/departmentTickets/all`,
    { headers: authHeaders(token) },
  );
  return data;
};

export const getDepartmentTicket = async (
  id: string,
  token: string,
  employeeId: string,
) => {
  const { data } = await axios.get<DepartmentTicketDetailsDto>(
    `${apiVariable}/departmentTickets/${id}`,
    { headers: authHeaders(token), params: { employeeId } },
  );
  return data;
};

export const getDepartmentTicketForHelper = async (
  id: string,
  token: string,
) => {
  const { data } = await axios.get<DepartmentTicketDetailsDto>(
    `${apiVariable}/departmentTickets/all/${id}`,
    { headers: authHeaders(token) },
  );
  return data;
};

export const createDepartmentTicket = async (
  payload: CreateDepartmentTicketDto,
  token: string,
) => {
  const { data } = await axios.post<DepartmentTicketDetailsDto>(
    `${apiVariable}/departmentTickets`,
    payload,
    { headers: authHeaders(token) },
  );
  return data;
};

export const addDepartmentTicketComment = async (
  id: string,
  payload: CreateDepartmentTicketCommentDto,
  token: string,
) => {
  const { data } = await axios.post<DepartmentTicketCommentDto>(
    `${apiVariable}/departmentTickets/${id}/comments`,
    payload,
    { headers: authHeaders(token) },
  );
  return data;
};

export const addDepartmentTicketCommentForHelper = async (
  id: string,
  payload: CreateDepartmentTicketCommentDto,
  token: string,
) => {
  const { data } = await axios.post<DepartmentTicketCommentDto>(
    `${apiVariable}/departmentTickets/all/${id}/comments`,
    payload,
    { headers: authHeaders(token) },
  );
  return data;
};

export const changeDepartmentTicketStatus = async (
  id: string,
  status: DepartmentTicketStatus,
  note: string,
  token: string,
  employeeId: string,
) => {
  const { data } = await axios.patch<DepartmentTicketDetailsDto>(
    `${apiVariable}/departmentTickets/${id}/status`,
    { status, note },
    { headers: authHeaders(token), params: { employeeId } },
  );
  return data;
};

export const changeDepartmentTicketStatusForHelper = async (
  id: string,
  status: DepartmentTicketStatus,
  note: string,
  token: string,
  employeeId: string,
) => {
  const { data } = await axios.patch<DepartmentTicketDetailsDto>(
    `${apiVariable}/departmentTickets/all/${id}/status`,
    { status, note },
    { headers: authHeaders(token), params: { employeeId } },
  );
  return data;
};

export const uploadDepartmentTicketFile = async (
  id: string,
  file: File,
  token: string,
  uploadedByEmployeeId: string,
) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await axios.post(
    `${apiVariable}/upload/${id}/departmentTicket`,
    formData,
    {
      headers: { ...authHeaders(token), "Content-Type": "multipart/form-data" },
      params: { uploadedByEmployeeId },
    },
  );
  return data;
};
